import React from 'react';
import PropTypes from 'prop-types';

import { formatDate, formatTime } from '../../../utils/dateFunctions';

import card from '../../../commonStyles/rowExpand.module.css';

const ActionHistory = ({ history }) => {
    return (
        <div className={card.cardView}>
            <div className={card.banner}>
                <span>Email: {history.emailAddress} </span>
                <span>Date: {formatDate(history.date) || ' - '}</span>
                <span>Time: {formatTime(history.date) || ' - '}</span>
                <span>New Action: {history.actionStatus || ' - '}</span>
            </div>

            <div className={card.content}>
                <p>
                    <span className={card.label}>Notes: {history.actionNotes || ' - '}</span>
                </p>
            </div>
        </div>
    );
};

ActionHistory.propTypes = {
    history: PropTypes.object
};

export default ActionHistory;
